'use strict';

import React from 'react';
import BaseItem from './BaseListItem';

class RentApartments extends BaseItem {
  render () {
    return super.render();
  }
}

export default RentApartments;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/ListItems/RentApartments.jsx